/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/UserLocal'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/UserLocal'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.UserLocalApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.UserLocal);
  }
}(this, function(ApiClient, UserLocal) {
  'use strict';

  /**
   * UserLocal service.
   * @module api/UserLocalApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new UserLocalApi. 
   * @alias module:api/UserLocalApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the userLocalAddUserIfEmailNotInUsePut operation.
     * @callback module:api/UserLocalApi~userLocalAddUserIfEmailNotInUsePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addUserIfEmailNotInUse
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserLocal} body 
     * @param {Boolean} skipCheck 
     * @param {Boolean} sendInvitation 
     * @param {module:api/UserLocalApi~userLocalAddUserIfEmailNotInUsePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userLocalAddUserIfEmailNotInUsePut = function(_4SAPIAppID, body, skipCheck, sendInvitation, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userLocalAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'skipCheck' is set
      if (skipCheck == undefined || skipCheck == null) {
        throw "Missing the required parameter 'skipCheck' when calling userLocalAddUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'sendInvitation' is set
      if (sendInvitation == undefined || sendInvitation == null) {
        throw "Missing the required parameter 'sendInvitation' when calling userLocalAddUserIfEmailNotInUsePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'skipCheck': skipCheck,
        'sendInvitation': sendInvitation
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/UserLocal/addUserIfEmailNotInUse', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLocalEditCurrentUserPut operation.
     * @callback module:api/UserLocalApi~userLocalEditCurrentUserPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editCurrentUser
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserLocal} body 
     * @param {Object} opts Optional parameters
     * @param {String} opts.newPassword  (default to )
     * @param {module:api/UserLocalApi~userLocalEditCurrentUserPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.userLocalEditCurrentUserPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalEditCurrentUserPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userLocalEditCurrentUserPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'newPassword': opts['newPassword']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/UserLocal/editCurrentUser', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLocalEditUserIfEmailNotInUsePut operation.
     * @callback module:api/UserLocalApi~userLocalEditUserIfEmailNotInUsePutCallback
     * @param {String} error Error message, if any.
     * @param {'Integer'} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * editUserIfEmailNotInUse
     * @param {String} _4SAPIAppID 
     * @param {module:model/UserLocal} body 
     * @param {Integer} primarykey 
     * @param {module:api/UserLocalApi~userLocalEditUserIfEmailNotInUsePutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link 'Integer'}
     */
    this.userLocalEditUserIfEmailNotInUsePut = function(_4SAPIAppID, body, primarykey, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalEditUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling userLocalEditUserIfEmailNotInUsePut";
      }

      // verify the required parameter 'primarykey' is set
      if (primarykey == undefined || primarykey == null) {
        throw "Missing the required parameter 'primarykey' when calling userLocalEditUserIfEmailNotInUsePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'primarykey': primarykey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = 'Integer';

      return this.apiClient.callApi(
        '/UserLocal/editUserIfEmailNotInUse', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLocalLoadAllGet operation.
     * @callback module:api/UserLocalApi~userLocalLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserLocal>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserLocalApi~userLocalLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserLocal>}
     */
    this.userLocalLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserLocal];

      return this.apiClient.callApi(
        '/UserLocal/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLocalLoadGet operation.
     * @callback module:api/UserLocalApi~userLocalLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/UserLocal} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} primaryKey 
     * @param {module:api/UserLocalApi~userLocalLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/UserLocal}
     */
    this.userLocalLoadGet = function(_4SAPIAppID, primaryKey, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalLoadGet";
      }

      // verify the required parameter 'primaryKey' is set
      if (primaryKey == undefined || primaryKey == null) {
        throw "Missing the required parameter 'primaryKey' when calling userLocalLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'primaryKey': primaryKey
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = UserLocal;

      return this.apiClient.callApi(
        '/UserLocal/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the userLocalLoadUsersWithAccessToCurrentCompanyGet operation.
     * @callback module:api/UserLocalApi~userLocalLoadUsersWithAccessToCurrentCompanyGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/UserLocal>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadUsersWithAccessToCurrentCompany
     * @param {String} _4SAPIAppID 
     * @param {module:api/UserLocalApi~userLocalLoadUsersWithAccessToCurrentCompanyGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/UserLocal>}
     */
    this.userLocalLoadUsersWithAccessToCurrentCompanyGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling userLocalLoadUsersWithAccessToCurrentCompanyGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [UserLocal];

      return this.apiClient.callApi(
        '/UserLocal/loadUsersWithAccessToCurrentCompany', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
